"use strict";
function showDialog(modalId, resizable, draggable = true, callback, reShowIfAlreadyVisible = true) {
    if (!reShowIfAlreadyVisible && $(`#${modalId}`).is(`:visible`))
        return;
    $(`#${modalId}.modal`).appendTo(document.body);
    let iframe = $(`#${modalId} .modal-dialog .modal-content .modal-body iframe`);
    if (iframe) {
        let dataSrc = iframe.attr('data-src');
        if (dataSrc)
            iframe.attr('src', dataSrc);
    }
    if (draggable !== false) {
        $(`#${modalId} .modal-dialog`).draggable();
    }
    if (resizable) {
        $(`#${modalId} .modal-content`).resizable();
    }
    $(`#${modalId}`).on(`shown.bs.modal`, function (e) {
        $(document).off('focusin.modal');
        if (callback) {
            callback();
        }
    });
    $(`#${modalId}`).modal();
}
window.showDialog = showDialog;
function hideDialog(modalId) {
    $(`#${modalId}`).modal(`hide`);
}
window.hideDialog = hideDialog;
